import { render, staticRenderFns } from "./IndustrialMultiTenantIndustrialProperty.vue?vue&type=template&id=622b7a82&scoped=true&"
import script from "./IndustrialMultiTenantIndustrialProperty.vue?vue&type=script&lang=ts&"
export * from "./IndustrialMultiTenantIndustrialProperty.vue?vue&type=script&lang=ts&"
import style0 from "./IndustrialMultiTenantIndustrialProperty.vue?vue&type=style&index=0&id=622b7a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b7a82",
  null
  
)

export default component.exports